import { FunctionComponent } from "react";
import { Dialog, SubmissionForm } from "@bps/fluent-ui";

import { AddCouponFormFields } from "./AddCouponFormFields";
import {
  AddCouponFormDialogProps,
  AddCouponFormValues
} from "./AddCouponFormDialog.types";
import { Validator } from "@bps/validator";

const defaultValues: AddCouponFormValues = {
  coupons: []
};

const validator = new Validator<AddCouponFormValues>(validator => ({
  isNeedToApply: validator.boolean().required(),
  coupons: validator.custom().predicate({
    when: (_, values) => values.isNeedToApply === true,
    then: validator.array().required()
  })
}));

export const AddCouponFormDialog: FunctionComponent<AddCouponFormDialogProps> = ({
  excludePromotionCodeList,
  onDismiss,
  onConfirm
}) => {
  return (
    <Dialog
      hidden={false}
      dialogContentProps={{ title: "Add discount", showCloseButton: true }}
      minWidth={450}
      onDismiss={onDismiss}
    >
      <SubmissionForm<AddCouponFormValues>
        initialValues={defaultValues}
        onSubmit={async () => {}}
        validate={validator.validate}
        hideButtons
      >
        {() => {
          return (
            <AddCouponFormFields
              onConfirm={onConfirm}
              excludePromotionCodeList={excludePromotionCodeList}
            />
          );
        }}
      </SubmissionForm>
    </Dialog>
  );
};
